export default {
  name: 'World Strategic Forum',
  shortName: 'Toronto',
  description:
    'Le World Strategic Forum a été créé en 2011 et se tient chaque année à Miami, accueillant des participants du monde entier. Le WSF rassemble des décideurs de toutes les sphères de la société pour discuter des problèmes les plus urgents de notre époque.',
  thumbnail: '/images/events/miami/thumbnail-miami.jpg',
  link: 'https://www.worldstrategicforum.com/',
  header: {
    content:
      'Le World Strategic Forum a été créé en 2011 et se tient chaque année à Miami, accueillant des participants du monde entier. Le WSF rassemble des décideurs de toutes les sphères de la société pour discuter des problèmes les plus urgents de notre époque.'
  },
  bullets: {
    bullet1: {
      number: '12ème',
      label: 'Édition'
    },
    bullet2: {
      number: '1 000+',
      label: 'Participants'
    },
    bullet3: {
      number: '70+',
      label: 'Conférenciers'
    },
    bullet4: {
      number: '35+',
      label: 'Pays Représentés'
    }
  },
  about: {
    title: 'Notre objectif',
    content:
      'La mission du WSF est de relever les principaux défis actuels en matière d’entreprise et de gouvernance, tout en favorisant une meilleure compréhension des opportunités et des défis en jeu pour les Amériques au sein du marché mondial. Les thèmes centraux du WSF tournent autour de l’économie mondiale, de la finance, de la technologie, du commerce, de l’énergie, de l’infrastructure, de l’investissement et de la planification de la succession d’entreprise.'
  },
  next: {
    title: 'Mastering The New Economy',
    content:
      "Le monde évolue à grande vitesse, entraînant de nouvelles tendances et avancées émergentes, et de nombreux défis. L'édition 2023 du WSF examinera les façons dont nous pouvons innover, nous adapter et réussir au sein de la nouvelle économie mondiale. Rejoignez-nous pour des discussions enrichissantes et des opportunités de réseautage uniques les 6 et 7 novembre, lorsque nous réunirons des décideurs et des leaders internationaux autour du thème : « Mastering the New Economy »."
  },
  gallery: {
    title: 'Galerie de photos',
    index: [
      {
        title: '11ème édition — Investing in Trust',
        images: [
          '/images/events/miami/gallery/11th-miami-001.jpg',
          '/images/events/miami/gallery/11th-miami-002.jpg',
          '/images/events/miami/gallery/11th-miami-003.jpg',
          '/images/events/miami/gallery/11th-miami-004.jpg',
          '/images/events/miami/gallery/11th-miami-005.jpg',
          '/images/events/miami/gallery/11th-miami-006.jpg',
          '/images/events/miami/gallery/11th-miami-007.jpg',
          '/images/events/miami/gallery/11th-miami-008.jpg',
          '/images/events/miami/gallery/11th-miami-009.jpg',
          '/images/events/miami/gallery/11th-miami-010.jpg',
          '/images/events/miami/gallery/11th-miami-011.jpg',
          '/images/events/miami/gallery/11th-miami-012.jpg',
          '/images/events/miami/gallery/11th-miami-013.jpg',
          '/images/events/miami/gallery/11th-miami-014.jpg',
          '/images/events/miami/gallery/11th-miami-015.jpg',
          '/images/events/miami/gallery/11th-miami-016.jpg',
          '/images/events/miami/gallery/11th-miami-017.jpg',
          '/images/events/miami/gallery/11th-miami-018.jpg',
          '/images/events/miami/gallery/11th-miami-019.jpg',
          '/images/events/miami/gallery/11th-miami-020.jpg',
          '/images/events/miami/gallery/11th-miami-021.jpg'
        ]
      }
    ]
  }
}
